<script lang="ts">
  import { get } from 'svelte/store'
  import { useKeyboardListener } from '../../hooks'
  import { sceneMode } from '../../stores/scene-mode'
  import useCanvasSelection from '../../hooks/canvas-selection'

  const { object: canvasSelection, clear: clearSelection }
    = useCanvasSelection()

  $effect(() => {
    return useKeyboardListener('Escape', {
      onKeyUp: () => {
        const mode = get(sceneMode)
        if (mode !== 'default' && mode !== 'forbiddenZone') {
          sceneMode.set('default')
        }
        else if (mode === 'default' && get(canvasSelection)) {
          clearSelection()
        }
      },
    })
  })
</script>
